import type { VoidFunctionComponent } from 'react';
import ProjectAffiliationContainer from '../generic/ProjectAffiliation';
import { ActionCards } from '../overview/StandardProjectSummaryActionCards';
import type { ProjectSummaryProps } from '../projectDashboardTypes';
import { SidebarLayout } from '../../layouts';
import styles from './SBOMSummary.module.less';
import useSummaryActions from './useSummaryActions';
import Card from '../../generic/Card/Card';
import ModalStreamBuild from '../../modals/ModalStreamBuild';
import SBOMSummaryBuildProcess from './SBOMSummaryBuildProcess';
import SBOMAnalysisComponent from './SBOMAnalysis/SBOMAnalysisComponent';

/**
 * Topline statistics and actions for SBOM projects
 */
const SBOMSummary: VoidFunctionComponent<ProjectSummaryProps> = ({
  project,
  revision,
  baseUrl,
  params,
}) => {
  const {
    isRebuilding,
    onRebuild,
    rebuildBuildId,
    onShowNoDependenciesModal,
    onVisitAPIEndpoint,
    routerPush,
    onHideModalStreamBuild,
  } = useSummaryActions({
    revision,
    params,
  });
  return (
    <div className={styles.sbomSummary}>
      <SidebarLayout>
        <SidebarLayout.Main>
          <Card isFullWidth isContentFullHeight>
            <Card.Header>UNDER CONSTRUCTION</Card.Header>
            <Card.Content>
              <SBOMSummaryBuildProcess
                projectId={params.project_id}
                revisionId={params.revision_id}
                revision={revision}
              />
              {project.data.sbomPolicyId && revision?.data?.isSteady &&
                <SBOMAnalysisComponent
                  projectLocator={params.project_id}
                  revisionId={params.revision_id}
                  revisionBaseUrl={baseUrl}
                />}
            </Card.Content>
          </Card>
        </SidebarLayout.Main>
        <SidebarLayout.Sidebar>
          <ActionCards
            project={project}
            revision={revision}
            isScannedForIssues={false}
            revisionBaseUrl={baseUrl}
            isRebuilding={false}
            onRebuild={onRebuild}
            onShowNoDependenciesModal={onShowNoDependenciesModal}
            onVisitAPIEndpoint={onVisitAPIEndpoint}
            routerPush={routerPush}
          />
          <ProjectAffiliationContainer
            projectLocator={project.data.locator}
            labels={project.data.labels?.map((l) => l.label)}
          />
        </SidebarLayout.Sidebar>
      </SidebarLayout>
      {!project.data.require_mediated_dependencies && rebuildBuildId !== null && (
        <ModalStreamBuild
          key="rebuild-modal-stream-build"
          show={isRebuilding}
          buildId={rebuildBuildId}
          refId={params.reference}
          onHide={onHideModalStreamBuild} />
      )}
    </div>
  );
};

export default SBOMSummary;
